import { useState } from "react";
import DropDown from "../../components/dropdown/dropdown";
import InputForm from "../../components/input/input";
import ButtonLoading from "../../components/buttonLoading/buttonLoading";
import InputFormMask from "../../components/inputMask/inputMask";
import MotoristaService from "../../services/resource/motoristaService";

const initialValues = {
  id: '',
  name: '',
  branchId: ''
}

function MotoristaCreate({ branches, setShowModal, onChange }) {
  const [form, setForm] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setForm(prev => ({ ...prev, id: form.id.replace("-", "").replace("_", "") }))
    form.id = form.id.replaceAll("-", "").replaceAll("_", "");

    try {
      await new MotoristaService().create(form);
      setForm(initialValues);
      setShowModal(false);
      onChange()
    } catch (err) {
      setError(err.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <DropDown
          id="cadastroBranchId"
          label="Filial"
          label1="name"
          optionValue="id"
          optionLabel="name"
          optionIcon="image"
          name="branchId"
          disabled={loading}
          value={form.serviceTypeId}
          options={branches}
          onChange={handleChange}
        />
        <div>
          <InputFormMask
            type="text"
            name="id"
            mask="9999999999"
            placeholder="Código"
            value={form.id}
            onChange={handleChange}
            label="Código do Motorista"
          />
        </div>
        <div>
          <InputForm
            type="text"
            name="name"
            placeholder="Nome do Motorista"
            value={form.name}
            label="Nome do Motorista"
            onChange={handleChange}
          />
        </div>
      </div>
      {error && <p className="text-red-600 mt-2">{error}</p>}
      <div className="flex justify-end space-x-3 mt-4">
        <ButtonLoading
          id="cancel-import"
          type="text"
          color="gray"
          label="Cancelar"
          optional
          onClick={() => setShowModal(false)}
        />
        <ButtonLoading
          type="submit"
          label="Cadastrar motorista"
          color="blue"
          id="confirm-import"
          loading={loading}
        />
      </div>
    </form>
  );
};

export default MotoristaCreate;